import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import SubscribeFrom from 'react-mailchimp-subscribe'

import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import FacebookIcon from '@material-ui/icons/Facebook'
import InstagramIcon from '@material-ui/icons/Instagram'
import TwitterIcon from '@material-ui/icons/Twitter'

import { GA_ACTION, GA_EVENT, sendGAEvent } from '../analytics'

import './Footer.css'

import android from '../images/android_button.webp'
import apple from '../images/apple_button.webp'


const formProps = {
  action: '//broadwayroulette.us12.list-manage.com/subscribe/post?u=3c4c9afdbb28160af716b104d&id=d095aca221',
  messages: {
    inputPlaceholder: "Enter your email",
    btnLabel: "SUBMIT",
    success: "Success!",
    error: "Please enter a valid email or one that has not been used before"
  },
  styles: {
    sending: {
      fontSize: 12,
      color: "#000000"
    },
    success: {
      fontSize: 12,
      color: "#000000"
    },
    error: {
      fontSize: 12,
      color: "#000000"
    }
  }
}

class Footer extends Component {

  state = {
    mobileFooterCollapsedCol1: true,
    mobileFooterCollapsedCol2: false,
    mobileFooterCollapsedCol3: true,
    mobileFooterCollapsedCol4: true
  }

  trackFooterClick() {
    sendGAEvent(GA_EVENT.INTERACTION, GA_ACTION.INTERACTION.FOOTER_PRESS_CLICK)
  }

  render() {
    return (
      <div className="footer">
        <div className="container">
          <div className="footer-wrapper">
            <div className="footer-links">

              <div className="footer-column">
                <span className={"footer-title " + (this.state.mobileFooterCollapsedCol2 ? 'collapsed' : 'expanded')}
                      onClick={() => { this.setState({ mobileFooterCollapsedCol2: !this.state.mobileFooterCollapsedCol2 })}}>
                  West End's Return
                  <ExpandMoreIcon className="expand-more" />
                  <ExpandLessIcon className="expand-less" />
                </span>

                <div className="link">
                  <Link to={'/how-it-works'}
                        className='no-underline'
                        onClick={() => {
                          sendGAEvent(GA_EVENT.INTERACTION, GA_ACTION.INTERACTION.HOW_IT_WORKS_FOOTER)
                        }}>
                    How It Works
                  </Link>

                  <Link to={'/current-shows'} className='no-underline'>West End Shows</Link>
                </div>
              </div>

              <div className="footer-column">
                <span className={"footer-title " + (this.state.mobileFooterCollapsedCol1 ? 'collapsed' : 'expanded')}
                      onClick={() => { this.setState({ mobileFooterCollapsedCol1: !this.state.mobileFooterCollapsedCol1 })}}>
                  Learn More
                  <ExpandMoreIcon className="expand-more" />
                  <ExpandLessIcon className="expand-less" />
                </span>

                <div className="link">
                  <Link to={'/press'} className='no-underline'>Press</Link>
                  <Link to={'/faq'} className='no-underline'>Ticket FAQ</Link>
                </div>
              </div>

              <div className="footer-column">
                <span className={"footer-title " + (this.state.mobileFooterCollapsedCol3 ? 'collapsed' : 'expanded')}
                      onClick={() => { this.setState({ mobileFooterCollapsedCol3: !this.state.mobileFooterCollapsedCol3 })}}>
                  Company
                  <ExpandMoreIcon className="expand-more" />
                  <ExpandLessIcon className="expand-less" />
                </span>

                <div className="link">
                  <Link to={'/about'} className='no-underline'>About</Link>
                  <a href="http://blog.broadwayroulette.com" className='no-link-style'>Blog</a>
                  <Link to={'/careers'} className='no-underline'>Careers</Link>
                </div>
              </div>

              <div className="footer-column">
                <span className={"footer-title " + (this.state.mobileFooterCollapsedCol4 ? 'collapsed' : 'expanded')}
                      onClick={() => { this.setState({ mobileFooterCollapsedCol4: !this.state.mobileFooterCollapsedCol4 })}}>
                  Resources
                  <ExpandMoreIcon className="expand-more" />
                  <ExpandLessIcon className="expand-less" />
                </span>

                <div className="link">
                  <Link to={'/contact'} className='no-link-style'>Contact Us</Link>
                </div>
              </div>

              <div className="footer-column hidemobile">
                <span className="footer-title">Join Us</span>
                <span className="footer-social">
                  <a className="social-icon" href="https://www.instagram.com/broadwayroulette/?hl=en" target="_blank" rel="noopener noreferrer">
                    Instagram
                  </a>
                  <a className="social-icon" href="https://www.facebook.com/BroadwayRoulette/" target="_blank" rel="noopener noreferrer">
                    Facebook
                  </a>
                  <a className="social-icon" href="https://twitter.com/bwayroulette" target="_blank" rel="noopener noreferrer">
                    Twitter
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="copyright">
          <div className="container">

            <div className="email-wrapper">
              <div className="footer-email">
                <p className="email-header">Stay-in-the-know</p>
                <p className="email-text">All of the latest West End news and special offers. Zero spam.</p>
                <SubscribeFrom {...formProps} onSuccess={() => { sendGAEvent(GA_EVENT.INTERACTION, GA_ACTION.INTERACTION.FOOTER_SUBMIT) }}/>
              </div>
            </div>

            <div className="social-media-icons">
              <a className="social-icon" href="https://www.facebook.com/BroadwayRoulette/" target="_blank" rel="noopener noreferrer">
                <FacebookIcon color="secondary" />
              </a>
              <a className="social-icon" href="https://twitter.com/bwayroulette" target="_blank" rel="noopener noreferrer">
                <TwitterIcon color="secondary" />
              </a>
              <a className="social-icon" href="https://www.instagram.com/broadwayroulette/?hl=en" target="_blank" rel="noopener noreferrer">
                <InstagramIcon color="secondary" />
              </a>
            </div>

            <div className="copyright-links">
              <span>© 2023 Broadway Roulette</span>
              <span>|</span>
              <a href="/privacy" className='no-link-style'>Privacy Policy</a>
              <span>|</span>
              <a href="/terms" className='no-link-style'>Terms & Conditions</a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer
